/**
 * Skeleton — square skeleton tile used in the photo grid.
 * Used by PhotoTile (thumbnail loading) and the grid loading state.
 */

import { T } from '@/design/tokens';

export function Skeleton() {
  return (
    <div
      aria-hidden="true"
      style={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        inset: 0,
        background: T.border,
      }}
    />
  );
}
